/**
 * Loading reducer. isLoading controls whether the spinner should be shown.
 */

import { ActionTypes as types } from '../constants'

// initial data. Immutable.
const initialState = {
  isLoading: false,
  amount: {
    isLoading: false,
    latestAmountFetchTime: null,
  },
  xoom: {
    isLoading: false,
  },
}

/**
 * loading.isLoading refers to the spinner overlay
 * loading.amount.isLoading refers to the loader in the amount field for the calculator
 */
function loading(state = initialState, action) {
  switch (action.type) {
    // show spinner for these
    case types.REQUEST_DESTINATION_AMOUNT:
    case types.REQUEST_ORIGIN_AMOUNT:
      return {
        ...state,
        amount: {
          ...state.amount,
          latestAmountFetchTime: action.data.latestAmountFetchTime,
          isLoading: true,
        },
      }
    // NO spinner for these
    case types.RECEIVED_ORIGIN_AMOUNT:
    case types.RECEIVED_CURRENCY_CODE_LIST:
    case types.RECEIVED_DESTINATION_AMOUNT:
    case types.RECEIVED_FEE:
      return {
        ...state,
        amount: {
          ...state.amount,
          isLoading: false,
        },
      }

    case types.REQUEST_RECIPIENT_DETAILS:
    case types.REQUEST_COUNTRY_DATA:
      return {
        ...state,
        isLoading: true,
      }

    case types.RECEIVED_RECIPIENT_DETAILS:
    case types.RECEIVED_COUNTRY_DATA:
      return {
        ...state,
        isLoading: false,
      }

    case types.SHOW_ERROR_BANNER: // when you have an error hide the loader...
      return {
        ...state,
        isLoading: false,
        amount: {
          ...state.amount,
          isLoading: false,
        },
      }
    // return state for default use case
    default:
      return state
  }
}

export default loading
